// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"524":"fb4ecb69","562":"241e55a2","774":"c8c88e90","787":"ec5af9f8"}[chunkId] + ".chunk.js";
};